import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import Image from 'components/Image';
import Link from 'components/Link';
import zparse from 'utils/zparse';

const SimpleCard = ({ title, subtitle, intro, photo, uri, cta = 'Learn More', className = '' }) => {
	if (!title) return null;

	const introContent = typeof intro === 'string' ? (intro || '').trim() : intro;

	return (
		<Box className={`SimpleCard-root ${className}`.trim()}>
			{photo && (
				<Box className="SimpleCard-media">
					<Image
						src={photo}
						alt={title}
						layout={Image.COVER}
						width={369}
						height={207}
						classPrefix="SimpleCardImage"
					/>
				</Box>
			)}

			<Box className="SimpleCard-divider" aria-hidden="true" />

			<Typography component="div" variant="h4" className="SimpleCard-title">
				{uri ? <Link href={uri}>{title}</Link> : title}
				{ subtitle && <Typography component="div" variant="body2">{subtitle}</Typography> }
			</Typography>


			{introContent && (
				<Typography component="div" className="SimpleCard-intro">
					{zparse(introContent)}
				</Typography>
			)}

			{cta && uri && (
				<Link href={uri} className="SimpleCard-cta">
					{cta}
				</Link>
			)}
		</Box>
	);
};

export default React.memo(SimpleCard);
